/*
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

SmoothScroll({ animationTime: 800 });

jQuery(document).ready(function ($) {
	var stickyHeaderWidth = 1200;
	var stickyHeaderStart = 100;
	var headerOffset    = 62; // Height of sticky header
	var menuResizeWidth = 959;

	//--------------------------------------------
	// Menus
	//--------------------------------------------

	$("#header-a #main-menu, #header-b #main-menu, #header-d #main-menu").argonmenu({
		resizeWidth: menuResizeWidth,
		collapserTitle: "",
		animSpeed: "medium",
		easingEffect: null,
		indentChildren: false,
		childrenIndenter: "&nbsp;",
		expandIcon:
			'<span class="sub-collapser"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M308.7 427.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 393.4 171.3 244.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6l160 160z"/></svg></span>',
		collapseIcon:
			'<span class="sub-collapser"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M308.7 212.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6-6.2 6.2-16.4 6.2-22.6 0L320 246.6 171.3 395.3c-6.2 6.2-16.4 6.2-22.6 0-6.2-6.2-6.2-16.4 0-22.6l160-160z"/></svg></span>',
	});

	$('#main-menu a[href="#"]').click(function () {
		if ($(window).width() <= menuResizeWidth) {
			$(this).parent().find("> .sub-toggle").click();
		}

		return false;
	});

	// $("#header-c .nav-icon").click(function () {
	// 	$("body").toggleClass("nav-open");
	// });

	//--------------------------------------------
	// Sticky Header
	//--------------------------------------------

	var stickyHeader = $("#header-a, #header-b, #header-c, #header-d");

	function rpjcStickyHeader() {
		var screenSize = $(window).width(),
			scrollTop = $(document).scrollTop(),
			wrapper = $("#wrapper");

		if (screenSize < stickyHeaderWidth) return;

		if (scrollTop > stickyHeaderStart) {
			$(stickyHeader).addClass("stuck");
			$(wrapper).addClass("header-stuck");
		} else {
			$(stickyHeader).removeClass("stuck");
			$(wrapper).removeClass("header-stuck");
		}
	}

	rpjcStickyHeader();

	$(window).scroll(rpjcStickyHeader);

	//--------------------------------------------
	// Site Search
	//--------------------------------------------

	$(".toggle-search").click(function () {
		$("body").toggleClass("search-open");

		$('.site-search input[type="text"]').focus();

		return false;
	});

	$(".site-search-close").click(function () {
		$("body").toggleClass("search-open");

		return false;
	});

	//--------------------------------------------
	// Sliders
	//--------------------------------------------

	// Default Sliders

	var defaultSliders = document.querySelectorAll(".default-slider .splide");

	defaultSliders.forEach((slider) => {
		new Splide(slider, {
			type: "loop",
			perPage: 1,
			pauseOnFocus: true,
		}).mount();
	});

	// Logo Scrollers

	var logoScrollers = document.querySelectorAll(".logo-scroller .splide");

	logoScrollers.forEach((slider) => {
		var logoScroller = new Splide(slider, {
			type: "loop",
			gap: 20,
			autoplay: true,
			interval: 3000,
			perPage: 5,
			perMove: 1,
			arrows: false,
			pagination: false,
			breakpoints: {
				960: {
					perPage: 4,
				},
				768: {
					perPage: 3,
				},
				480: {
					perPage: 2,
				},
			},
		});

		logoScroller.on("mounted resized", function () {
			if (logoScroller.length <= logoScroller.options.perPage) {
				logoScroller.options.perPage = logoScroller.length;
			}
		});

		logoScroller.mount();
	});

	// Testimonial Scrollers

	var testimonialScrollers = document.querySelectorAll(".section-testimonials .splide");

	testimonialScrollers.forEach((slider) => {
		new Splide(slider, {
			type: "loop",
			perPage: 1,
			gap: 50,
			arrows: false,
			pagination: true,
			autoplay: true,
			interval: 15000,
			speed: 400,
			rewind: true,
			pauseOnFocus: true,
		}).mount();
	});

	// Section Sliders

	var sectionSliders = document.querySelectorAll(".section-slider .splide");

	sectionSliders.forEach((slider) => {
		new Splide(slider, {
			type: "fade",
			perPage: 1,
			arrows: false,
			pagination: true,
			autoplay: true,
			interval: 5000,
			speed: 2000,
			pauseOnFocus: true,
		}).mount();
	});

	// Landing Slider

	var landingSlider = document.querySelector("#landing .splide");

	if (landingSlider) {
		const landingSliderSplide = new Splide(landingSlider, {
			type: "fade",
			rewind: true,
			perPage: 1,
			autoplay: true,
			interval: 7000,
			speed: 2000,
			arrows: false,
			pagination: true,
			pauseOnHover: false
		});

		landingSliderSplide.on("pagination:updated", function () {
			if (landingSliderSplide.length === 1) {
				$("#landing .splide__pagination").hide();
			} else {
				$("#landing .splide__pagination").show();
			}
		});

		landingSliderSplide.mount();
	}

	//--------------------------------------------
	// Lightbox
	//--------------------------------------------

	$(".lightbox-image").magnificPopup({
		closeBtnInside: false,
		mainClass: "rpjc-magnific",
		closeMarkup:
			'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
		type: "image",
	});

	$(".lightbox-image.wp-block-image").magnificPopup({
		delegate: "a",
		closeBtnInside: false,
		mainClass: "rpjc-magnific",
		closeMarkup:
			'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
		type: "image",
	});

	$(".lightbox-iframe").magnificPopup({
		closeBtnInside: false,
		mainClass: "rpjc-magnific",
		closeMarkup:
			'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
		type: "iframe",
		iframe: {
			markup:
				'<div class="mfp-iframe-scaler">' +
				'<div class="mfp-close"></div>' +
				'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
				"</div>",
			patterns: {
				youtube: {
					index: "youtube.com/",
					id: "v=",
					src: "https://www.youtube.com/embed/%id%?autoplay=1",
				},
			},
		},
	});

	$(".lightbox-team").magnificPopup({
		closeBtnInside: false,
		mainClass: "rpjc-magnific rpjc-magnific-team",
		closeMarkup:
			'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
		type: "ajax",
		fixedContentPos: true,
		callbacks: {
			ajaxContentAdded: function () {
				$(".close-team-lightbox").click(function (e) {
					e.preventDefault();
					$.magnificPopup.close();
				});
			},
		},
	});

	$(".lightbox-gallery, .masonry-gallery").each(function() {
		var svgRight =
			'<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M427.3 308.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0-6.2-6.2-6.2-16.4 0-22.6L393.4 320 244.7 171.3c-6.2-6.2-6.2-16.4 0-22.6 6.2-6.2 16.4-6.2 22.6 0l160 160z"/></svg>';

		$(this).magnificPopup({
			delegate: "a",
			closeBtnInside: false,
			mainClass: "rpjc-magnific",
			closeMarkup:
				'<div title="%title%" class="mfp-close"><svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M507.3 155.3c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L320 297.4 155.3 132.7c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6L297.4 320 132.7 484.7c-6.2 6.2-6.2 16.4 0 22.6 6.2 6.2 16.4 6.2 22.6 0L320 342.6l164.7 164.7c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L342.6 320l164.7-164.7z"/></svg></div>',
			type: "image",
			closeOnBgClick: false,
			gallery: {
				enabled: true,
				arrowMarkup: '<div class="mfp-arrow mfp-arrow-%dir%">' + svgRight + "</div>",
			},
		});
	});

	//--------------------------------------------
	// Accordion
	//--------------------------------------------

	$(".accordion .accordion-content").hide();

	var hash = window.location.hash;

	// Check if there's hash tag in the URL
	if (hash.length) {
		var selectedAccordionItem = $("body").find(".accordion .accordion-item" + hash);

		// If yes, open the matching accordion item
		if (selectedAccordionItem.length) {
			var scrollPx = selectedAccordionItem.offset().top - headerOffset;

			selectedAccordionItem.addClass("selected").find(".accordion-content").show();

			// Perform scroll down
			$("html, body").animate({ scrollTop: scrollPx }, "slow");
		}
	}

	if ("onhashchange" in window) {
		// detect hash url changes
		$(window).on("hashchange", function (e) {
			//hide open accordion
			$(".accordion-item").removeClass("selected");
			$(".accordion-content").hide();

			var hash = window.location.hash;

			var selectedAccordionItem = $("body").find(".accordion .accordion-item" + hash);

			// If yes, open the matching accordion item
			if (selectedAccordionItem.length) {
				var scrollPx = selectedAccordionItem.offset().top - headerOffset;

				selectedAccordionItem.addClass("selected").find(".accordion-content").show();

				// Perform scroll down
				$("html, body").animate({ scrollTop: scrollPx }, "slow");
			}
		});
	}

	$(".accordion-handle").click(function () {
		var accordion = $(this).parent().parent();

		if ($(".accordion-content").not(":animated")) {
			if ($(this).parent().hasClass("selected")) {
				$(this).next().slideUp(300).end().parent().removeClass("selected");
			} else {
				$(accordion).find(".accordion-item").removeClass("selected");
				$(this).parent().addClass("selected");
				$(accordion).find(".accordion-content").slideUp(300);
				$(this).next().slideDown(300);
			}
		}

		return false;
	});

	//--------------------------------------------
	// Tabs
	//--------------------------------------------

	$(".tabbed-content .tab-nav li:first-child").addClass("active");
	$(".tabbed-content .tab-window .tab-panel").not(":first-child").hide();

	// Check if there's hash tag in the URL
	if (hash.length) {
		var selectedTabPanel = $("body").find(".tabbed-content .tab-window " + hash);

		// If yes, open the matching tab item
		if (selectedTabPanel.length) {
			var scrollPx = selectedTabPanel.offset().top - headerOffset;

			$(".tabbed-content .tab-window .tab-panel").hide();
			$('.tabbed-content .tab-nav li a[href="' + hash + '"]')
				.parent()
				.addClass("active")
				.siblings()
				.removeClass("active");

			selectedTabPanel.show().siblings().hide();

			// Perform scroll down
			$("html, body").animate({ scrollTop: scrollPx }, "slow");
		}
	}

	$(".tabbed-content .tab-nav a").click(function () {
		var target = $(this).attr("href");

		$(this).parent().addClass("active").siblings().removeClass("active");

		$(target).show().siblings().hide();

		return false;
	});

	//--------------------------------------------
	// Scrolling
	//--------------------------------------------

	// Scroll to element

	$(".scroll-to").click(function () {
		var selected = $(this).attr("href"),
			scrollPx = $(selected).offset().top - headerOffset;

		$("html, body").animate({ scrollTop: scrollPx }, "slow");

		return false;
	});

	// Scroll to top link

	$('a[href="#top"]').click(function () {
		$("html, body").animate({ scrollTop: 0 }, "slow");

		return false;
	});

	//--------------------------------------------
	// Responsive Horizontal Scrolling
	//--------------------------------------------

	$(".responsive-scroll").each(function () {
		var element = $(this),
			scrollWrapper = $("<div />", {
				class: "scrollable",
				html: '<div class="scrollable-inner" />',
			}).insertBefore(element);

		element.data("scrollWrapper", scrollWrapper);
		element.appendTo(scrollWrapper.find("div"));

		if (element.outerWidth() > element.parent().outerWidth()) {
			element.data("scrollWrapper").addClass("has-scroll");
		}

		$(window).on("resize orientationchange", function () {
			if (element.outerWidth() > element.parent().outerWidth()) {
				element.data("scrollWrapper").addClass("has-scroll");
			} else {
				element.data("scrollWrapper").removeClass("has-scroll");
			}
		});
	});

	//--------------------------------------------
	// fitVids
	//--------------------------------------------

	$(".main").fitVids();

	//--------------------------------------------
	// Read More
	//--------------------------------------------

	$(".read-more-content").hide();

	$(".read-more-button a").on("click", function (e) {
		e.preventDefault();

		var readMoreButton = $(this),
			moreText = readMoreButton.attr("data-more"),
			lessText = readMoreButton.attr("data-less");

		$(readMoreButton)
			.parent()
			.next()
			.not(":animated")
			.slideToggle(300, function () {
				if ($(this).is(":visible")) {
					readMoreButton.html(lessText);
				} else {
					readMoreButton.html(moreText);
				}
			});
	});

	//--------------------------------------------
	// Team B
	//--------------------------------------------

	$(".team-b .person a").click(function (e) {
		e.preventDefault();

		var target = $(this).attr("href");

		$(".person-details").removeClass("active");

		if ($(this).parent().hasClass("active")) {
			$(this).parent().removeClass("active");

			$(target).removeClass("active");
		} else {
			$(this).parent().addClass("active").siblings(".person").removeClass("active");

			$(target).addClass("active");
		}
	});

	$(".person-details .close").click(function () {
		$(".team-b .person").removeClass("active");
		$(".team-b .person-details").removeClass("active");
	});

	//--------------------------------------------
	// Gallery Page Masonry Layout
	//--------------------------------------------

	var $masonryGallery = $('.masonry-gallery').imagesLoaded( function() {
		
		$masonryGallery.masonry({
			itemSelector: '.masonry-gallery__item',
			percentPosition: true,
			columnWidth: '.masonry-gallery__sizer',
			gutter: '.masonry-gallery__gutter'
		});

	});

	$masonryGallery.on( 'layoutComplete', function() {

		ScrollTrigger.refresh();

	});

	//--------------------------------------------
	// Quick Links Hover
	//--------------------------------------------

	document.querySelectorAll(".section-quick-links").forEach(section => {
	
		const cursor = section.querySelector(".section-quick-links__cursor");
		const links = section.querySelectorAll(".quick-links__image");

		if (!cursor || !links.length) return;

		links.forEach(link => {
			link.addEventListener("mouseenter", () => {
				cursor.classList.add("is-visible");
			});

			link.addEventListener("mouseleave", () => {
				cursor.classList.remove("is-visible");
			});

			link.addEventListener("mousemove", (e) => {
			
				const rect = section.getBoundingClientRect();

				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;

				cursor.style.left = `${x - 34}px`;
				cursor.style.top = `${y - 9}px`;
		
			});
		
		});

	});

	//--------------------------------------------
	// Upcoming Events Hover
	//--------------------------------------------

	document.querySelectorAll(".upcoming-events").forEach(section => {
	
		const cursor = section.querySelector(".upcoming-events__cursor");
		const links = section.querySelectorAll(".event__image");

		if (!cursor || !links.length) return;

		links.forEach(link => {
			link.addEventListener("mouseenter", () => {
				cursor.classList.add("is-visible");
			});

			link.addEventListener("mouseleave", () => {
				cursor.classList.remove("is-visible");
			});

			link.addEventListener("mousemove", (e) => {
			
				const rect = section.getBoundingClientRect();

				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;

				cursor.style.left = `${x - 34}px`;
				cursor.style.top = `${y - 9}px`;
		
			});
		
		});

	});

	//--------------------------------------------
	// Post Gallery Hover
	//--------------------------------------------

	document.querySelectorAll(".post-detail-a__gallery").forEach(section => {
	
		const cursor = section.querySelector(".post-detail-a__gallery-cursor");
		const links = section.querySelectorAll(".post-detail-a__gallery a");

		if (!cursor || !links.length) return;

		links.forEach(link => {
			link.addEventListener("mouseenter", () => {
				cursor.classList.add("is-visible");
			});

			link.addEventListener("mouseleave", () => {
				cursor.classList.remove("is-visible");
			});

			link.addEventListener("mousemove", (e) => {
			
				const rect = section.getBoundingClientRect();

				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;

				cursor.style.left = `${x - 34}px`;
				cursor.style.top = `${y - 9}px`;
		
			});
		
		});

	});

	//--------------------------------------------
	// History
	//--------------------------------------------

	const historyItems = gsap.utils.toArray(".section-history__item");

	historyItems.forEach((item) => {
		
		ScrollTrigger.create({
		
			trigger: item,
			start: "top 50%",

			onEnter: () => item.classList.add("reveal"),
			onEnterBack: () => item.classList.add("reveal"),
			// onLeave: () => item.classList.remove("reveal"),
			// onLeaveBack: () => item.classList.remove("reveal"),

		});

	});

	document.querySelectorAll(".section-history").forEach(section => {
	
		const cursor = section.querySelector(".section-history__cursor");
		const links = section.querySelectorAll(".section-history__item-image a");

		if (!cursor || !links.length) return;

		links.forEach(link => {
			link.addEventListener("mouseenter", () => {
				cursor.classList.add("is-visible");
			});

			link.addEventListener("mouseleave", () => {
				cursor.classList.remove("is-visible");
			});

			link.addEventListener("mousemove", (e) => {
			
				const rect = section.getBoundingClientRect();

				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;

				cursor.style.left = `${x - 34}px`;
				cursor.style.top = `${y - 9}px`;
		
			});
		
		});

	});

	document.querySelectorAll(".blocks").forEach(section => {
	
		const cursor = section.querySelector(".blocks__cursor");
		const links = section.querySelectorAll(".block-link");

		if (!cursor || !links.length) return;

		links.forEach(link => {
			link.addEventListener("mouseenter", () => {
				cursor.classList.add("is-visible");
			});

			link.addEventListener("mouseleave", () => {
				cursor.classList.remove("is-visible");
			});

			link.addEventListener("mousemove", (e) => {
			
				const rect = section.getBoundingClientRect();

				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;

				cursor.style.left = `${x - 34}px`;
				cursor.style.top = `${y - 9}px`;
		
			});
		
		});

	});

});

//--------------------------------------------
// Business / Event Filters
//--------------------------------------------

var postFilter = document.querySelector('.filterable');

if (postFilter) {

	var mixer = mixitup(postFilter, {

		selectors: {
			target: 'article'
		},
		animation: {
			effects: 'fade translateY(100%) stagger(50ms)'
		},
		load: {
			filter: ':not(.hide-from-view-all)'
		},
		callbacks: {
			onMixEnd: function(state) {
				ScrollTrigger.refresh();
			}
		}

	});

	postFilter.classList.add('mixitup-ready');

	mixer.configure({
		animation: {
			effects: 'fade translateY'
		}
	});

	// -----------------------------------------
	// Subcategory navigation
	// -----------------------------------------

	var topButtons = document.querySelectorAll('.post-filter > ul button');
	var subcategoryGroups = document.querySelectorAll('.post-filter .subcategories');

	// Hide all subcategories immediately
	jQuery(subcategoryGroups).hide();

	// Top-level category buttons
	topButtons.forEach(function(button) {

		button.addEventListener('click', function() {

			// Remove current from all top-level items
			topButtons.forEach(function(btn) {
				btn.parentElement.classList.remove('current');
			});

			// Set current on clicked item
			this.parentElement.classList.add('current');

			var category = this.dataset.category;

			// Close all subcategories
			jQuery(subcategoryGroups)
				.stop(true, true)
				.slideUp(300);

			// Open selected subcategory group
			if (category) {

				var group = document.getElementById(
					'subcategory-' + category
				);

				if (group) {
					jQuery(group)
						.stop(true, true)
						.slideDown(300);
				}

			}

		});

	});

	// Subcategory buttons
	document.querySelectorAll('.subcategories button').forEach(function(button) {

		button.addEventListener('click', function() {

			var group = this.closest('.subcategories');
			var category = group.id.replace('subcategory-', '');

			// Keep this group open
			jQuery(subcategoryGroups)
				.not(group)
				.stop(true, true)
				.slideUp(300);

			jQuery(group)
				.stop(true, true)
				.slideDown(300);

			// Update current top-level category
			topButtons.forEach(function(btn) {

				btn.parentElement.classList.toggle(
					'current',
					btn.dataset.category === category
				);

			});

		});

	});

}

//--------------------------------------------
// GSAP
//--------------------------------------------

gsap.registerPlugin(SplitText, ScrollTrigger);

ScrollTrigger.config({
	autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize"
});

function initScrollAnimations() {

	const splitConfig = {
		lines: { duration: 0.8, stagger: 0.08 },
		words: { duration: 1, stagger: 0.06 },
		chars: { duration: 0.4, stagger: 0.01 }
	};

	document.querySelectorAll("[data-split]").forEach((el) => {

		const type = el.dataset.split || "words";

		const typesToSplit =
			type === "lines" ? ["lines"] :
			type === "words" ? ["lines", "words"] :
			["lines", "words", "chars"];

		SplitText.create(el, {
			type: typesToSplit.join(", "),
			mask: "lines",
			autoSplit: false,
			linesClass: "line",
			wordsClass: "word",
			charsClass: "letter",

			onSplit: function(instance) {

				const targets = instance[type];
				const config = splitConfig[type];

				const baseAnimation = {
					yPercent: 110,
					duration: config.duration,
					stagger: config.stagger,
					ease: "expo.out",
					onStart: () => {
						gsap.set(el, {
							visibility: "visible"
						});
					}
				};

				if (el.dataset.splitImmediate === "true") {
					return gsap.from(targets, baseAnimation);
				}

				return gsap.from(targets, {
					...baseAnimation,
					scrollTrigger: {
						trigger: el,
						start: "top 80%",
						once: true
					}
				});
			}
		});

	});

	gsap.utils.toArray(".image-scroller").forEach((section) => {

		const scroller1 = section.querySelector(".scroller-1");
		const scroller2 = section.querySelector(".scroller-2");

		if (scroller1) {
			gsap.to(scroller1, {
				x: "-20vw",
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true
				}
			});
		}

		if (scroller2) {
			gsap.to(scroller2, {
				x: "0",
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true
				}
			});
		}

	});

	gsap.utils.toArray(".quick-links-lead").forEach((section) => {

		gsap.fromTo(
			section,
			{
				opacity: 0
			},
			{
				opacity: 1,
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: "top bottom",
					end: "bottom bottom",
					scrub: true,
					invalidateOnRefresh: true
				}
			}
		);

	});

	document.querySelectorAll(".section-quick-links").forEach((section) => {

		const items = section.querySelectorAll(".quick-links li");

		items.forEach((el) => {

			const startY = gsap.utils.random(60, 200);

			gsap.fromTo(
				el,
				{
					y: startY
				},
				{
					y: 0,
					ease: "none",
					scrollTrigger: {
						trigger: el,
						start: "top bottom",
						end: "top top",
						scrub: true,
						invalidateOnRefresh: true
					}
				}
			);

		});

	});

	document.querySelectorAll(".text-reveal").forEach((el) => {

		const words = el.textContent.trim().split(/\s+/);

		el.innerHTML = words
			.map(word => `<span class="word">${word}</span>`)
			.join(" ");

		const spans = el.querySelectorAll(".word");

		gsap.set(spans, {
			y: 20,
			opacity: 0.3
		});

		gsap.to(spans, {
			y: 0,
			opacity: 1,
			stagger: 0.1,
			ease: "none",
			scrollTrigger: {
				trigger: el,
				start: "top 85%",
				end: "bottom 50%",
				scrub: true,
				invalidateOnRefresh: true
			}
		});

	});

	gsap.utils.toArray(".cta-a__inner").forEach((box) => {

		gsap.set(box, {
			"--clip": "10%"
		});

		gsap.to(box, {
			"--clip": "0%",
			ease: "power2.out",
			immediateRender: false,
			scrollTrigger: {
				trigger: box,
				start: "top 100%",
				end: "center 50%",
				scrub: true,
				invalidateOnRefresh: true
			}
		});

	});


	document.querySelectorAll(".cta-a").forEach((section) => {

		const ctaBg = section.querySelector(".cta-a__background");
		const ctaText = section.querySelector(".cta-a__text");

		if (ctaBg) {

			gsap.fromTo(
				ctaBg,
				{
					yPercent: -15
				},
				{
					yPercent: 15,
					ease: "none",
					immediateRender: false,
					scrollTrigger: {
						trigger: section,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						invalidateOnRefresh: true
					}
				}
			);

		}

		if (ctaText) {

			gsap.fromTo(
				ctaText,
				{
					y: 100
				},
				{
					y: -100,
					ease: "none",
					immediateRender: false,
					scrollTrigger: {
						trigger: section,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						invalidateOnRefresh: true
					}
				}
			);

		}

	});

	gsap.fromTo(
		".sitefooter__tagline",
		{
			y: -100
		},
		{
			y: 0,
			ease: "none",
			immediateRender: false,
			scrollTrigger: {
				trigger: ".sitefooter__2",
				start: "top bottom",
				end: "bottom bottom",
				scrub: true,
				invalidateOnRefresh: true
			}
		}
	);


	gsap.fromTo(
		".sitefooter__logo",
		{
			y: -100
		},
		{
			y: 0,
			ease: "none",
			immediateRender: false,
			scrollTrigger: {
				trigger: ".sitefooter__2",
				start: "top bottom",
				end: "bottom bottom",
				scrub: true,
				invalidateOnRefresh: true
			}
		}
	);

	ScrollTrigger.refresh();

}

document.addEventListener("DOMContentLoaded", () => {

	// Wait for images.
	imagesLoaded(document.body, () => {

		// Give layout/fonts/browser a chance to settle.
		requestAnimationFrame(() => {

			requestAnimationFrame(() => {

				initScrollAnimations();

			});

		});

	});

});

document.querySelectorAll("video").forEach((video) => {

	video.addEventListener("loadedmetadata", () => {

		requestAnimationFrame(() => {
			ScrollTrigger.refresh();
		});

	});

});